import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'massiveFilter'
})
export class MassiveFilterPipe implements PipeTransform {

  transform(value: any[], text): any[] {
    let response = []

    value.map(
      test => {
        if (test[0].formName.toLowerCase().includes(text.toLowerCase()) || test[0].tag.toLowerCase().includes(text.toLowerCase())){
          response.push(test)
        }
      }
    )

    return response
  }

}
